import { atom as o } from "jotai";
import { atomWithDefault as n } from "jotai/utils";
const u = o(0), a = n((t) => t(u)), s = o(!0), r = n(
  (t) => t(s)
), g = () => o((t) => t(s)), f = o((t) => t(a)), y = o(
  null,
  (t, e, m) => {
    e(r, m);
  }
), i = o(
  null,
  (t, e, m) => {
    e(a, m);
  }
), S = o({
  onNextStep: () => !0
}), d = o(
  null,
  (t, e, m) => {
    e(S, {
      onNextStep: m
    });
  }
), c = o(!1), l = n(
  (t) => t(c)
), h = o((t) => t(l)), x = o(
  null,
  (t, e, m) => {
    e(l, m);
  }
);
export {
  r as bookingSummaryShowAtom,
  s as bookingSummaryShowAtomDefault,
  g as createDefaultBookingSummaryShowAtom,
  h as getOpenSummaryModalAtom,
  f as getStepAtom,
  S as handleNextStepAtom,
  l as openSummaryModalAtom,
  c as openSummaryModalAtomDefault,
  y as setBookingSummaryShowAtom,
  i as setCurrentStepAtom,
  d as setHandleNextStepAtom,
  x as setOpenSummaryModalAtom,
  a as stepAtom,
  u as stepAtomDefault
};
